import React from "react";
import { LoaderWrapper } from "./styles";

export function Loader({ top = 50, left = 50 }: { top?: number; left?: number }) {
  return (
      <LoaderWrapper top={top} left={left}/>
  );
}
